import script from "./CookView.vue?vue&type=script&lang=ts&setup=true"
export * from "./CookView.vue?vue&type=script&lang=ts&setup=true"

import "./CookView.vue?vue&type=style&index=0&id=5569746e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5569746e"]])

export default __exports__